// localStorage helpers for HTC progression.
// Stored shape: { [chapterId:string]: true }  — only completed chapters are kept.

const STORAGE_KEY = "vtpTutorialProgress";

function safeParse(raw) {
  if (!raw) return {};
  try {
    const v = JSON.parse(raw);
    return v && typeof v === "object" && !Array.isArray(v) ? v : {};
  } catch {
    return {};
  }
}

export function readProgress() {
  try {
    return safeParse(localStorage.getItem(STORAGE_KEY));
  } catch {
    return {};
  }
}

export function isChapterCompleted(id) {
  const map = readProgress();
  return map[String(id)] === true;
}

export function setChapterCompleted(id, completed = true) {
  const map = readProgress();
  const key = String(id);
  if (completed) {
    map[key] = true;
  } else {
    delete map[key];
  }
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(map));
  } catch {
    /* quota exceeded — ignore silently */
  }
  // Notify sidebar & other listeners within the same tab.
  window.dispatchEvent(
    new CustomEvent("vtpTutorialProgress:change", { detail: { id: key, completed } })
  );
  return map;
}

export function countCompleted() {
  return Object.values(readProgress()).filter(Boolean).length;
}
